import get from 'lodash/get';
import find from 'lodash/find';
import { useEffect, useState } from 'react';
import type { ITicketsController } from '../lib/widget/tickets/tickets.interface';
import { useInjection } from 'inversify-react';
import { TICKETS_MODULE_IDS } from '../lib/widget/tickets/tickets.types';

const useCounter = ({ data, isCategory }) => {
  const ticketsController: ITicketsController = useInjection(TICKETS_MODULE_IDS.TICKETS_CONTROLLER);
  const { Widget } = window;
  const { selectedEvent } = Widget.metaController;
  const initialCount = () => {
    if (isCategory) {
      return get(window.Widget.categoriesController.selectedCategories[data.id], 'count', 0);
    }
    const match = find(ticketsController.selectedTickets, (ticket) => ticket.id === data.id);
    return (match && match.count) || 0;
  };

  const [count, setCount] = useState(initialCount());

  const updateCount = () => {
    setCount(initialCount());
  };

  useEffect(() => {
    ticketsController.addListener(ticketsController.events.SET_NEW_SELECTED_TICKETS, updateCount);
    ticketsController.addListener(ticketsController.events.REMOVE, updateCount);
    return () => {
      ticketsController.removeListener(
        ticketsController.events.SET_NEW_SELECTED_TICKETS,
        updateCount,
      );
      ticketsController.removeListener(ticketsController.events.REMOVE, updateCount);
    };
  }, []);

  useEffect(() => {
    updateCount();
  }, [data.id]);

  const onCountChange = (_name, val) => {
    const ticket = { ...data, count: val, ...(selectedEvent && { selectedEvent }) };

    if (val) {
      ticketsController.addCounterTicket(ticket);
    } else {
      ticketsController.removeCounterTicket(ticket);
    }
    setCount(val);
  };

  const onCategoryCountChange = (_name, val) => {
    if (val > count) {
      window.Widget.categoriesController.add(data.id, val);
    } else {
      window.Widget.categoriesController.remove(data.id, val);
    }

    setCount(val);
  };

  return { count, onCategoryCountChange, onCountChange };
};

export default useCounter;
